var map = {
	"./ig1.png": 963,
	"./ig2.png": 353,
	"./ig3.png": 701,
	"./ig4.png": 220,
	"./igsec1.png": 90,
	"./igsec2.png": 702,
	"./igsec3.png": 223,
	"./igsec4.png": 962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;